import { IMAGE_LOCAL } from '@/common/constants';

export default {
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  created() {
    this.IMAGE_LOCAL = IMAGE_LOCAL;
  }
};
